export default __webpack_public_path__ + "static/media/third-place.48a7e30a.svg";